import { useCallback, useState } from "react";

const PREFIX = "wtfpl.info.seen.";

const readFlag = (key) => {
  try {
    return window.localStorage.getItem(PREFIX + key) !== null;
  } catch (e) {
    return true;
  }
};

const writeFlag = (key) => {
  try {
    window.localStorage.setItem(PREFIX + key, "1");
    return true;
  } catch (e) {
    return false;
  }
};

export const usePersistedFlag = (key) => {
  const [isSet, setIsSet] = useState(() => readFlag(key));

  const set = useCallback(() => {
    writeFlag(key);
    setIsSet(true);
  }, [key]);

  return [isSet, set];
};
